import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({children}) => {

    const {token} = useSelector((state) => state.auth);
    const location = useLocation();

    if(token !== null)
        return children
    else
        return <Navigate to="/login" state={{ from: location }} />

}

export default PrivateRoute
